import Modal from './Modal.js';
import { extractDateAndTimeFromTimestamp } from '../shared/utilities.js';
import { useLanguage } from '../context/LanguageContext.js';
import { usei18n } from '../i18n/i18n.js';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ dose, onConfirm, onClose }) => {
    const { language } = useLanguage();
    const [date, time] = extractDateAndTimeFromTimestamp(dose.timestamp, language);
    const i18n = usei18n(language);
    return (
        <Modal onClose={onClose} onBackdropClick={onClose} id="delete-confirmation">
            <div className="entry-details">
                <p className="date">{date}</p>
                <p className="time">
                    {time}, {dose.letter ? <span className="size">{dose.letter}</span> : (
                        <>
                            <span className="size">{dose.size}</span>&nbsp;
                            <span className="units">{i18n('doseUnit')}</span>
                        </>
                    )}
                </p>
            </div>
            <p className="warning-message">{i18n('modal.deleteConfirmation.message')}</p>
            <button className="warning-button delete" onClick={onConfirm}>{i18n('modal.deleteConfirmation.delete')}</button>
        </Modal>
    );
}

export default DeleteConfirmationModal;
